import Link from "next/link";
import Image from "next/image";
import { ArrowRightIcon } from "lucide-react";

import cn from "@/lib/cn";

export const ScoutProgramsCard = () => {
	return (
		<div className="relative overflow-hidden rounded-lg bg-brand-primary p-6 text-white">
			<Image
				className="absolute inset-0 -z-0"
				src="/images/stripes-blue.png"
				alt="stripes"
				width={300}
				height={300}
			/>

			<div className="relative flex flex-col">
				<div className="mb-20">
					<h4 className="mb-3 text-2xl font-medium">
						We run <b>Scout Programs</b> for PropTech VCs
					</h4>
					<p className="text-sm leading-5">Starting with a fund size of 200K</p>
				</div>

				<Link
					href="#"
					className={cn(
						"relative mt-auto rounded-md bg-gray-50 p-3 text-center text-brand-primary",
						"flex w-full items-center justify-center gap-2 text-sm font-semibold"
					)}
				>
					Coming Soon
					<ArrowRightIcon className="h-4 w-4" />
				</Link>
			</div>
		</div>
	);
};
